// extracted by mini-css-extract-plugin
export default {"aeroLogo":"ProtectedRoutes_aeroLogo__NEonF","navbar":"ProtectedRoutes_navbar__xZFqk"};